import { Link } from 'gatsby'
import styled from 'styled-components'

const HeaderWrapper = styled.header`
  position: sticky;
  top: -0.5px;
  width: 100%;
  height: 60px;
  background: ${({ theme }) => theme.color.ui4};
  color: ${({ theme }) => theme.color.text1};
  box-shadow: inset 0 -1px 0px 0px rgba(255, 255, 255, 0.1);
  z-index: 100;
  overflow: hidden;
`
const HeaderInnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`
const HeaderButton = styled.a`
  height: 100%;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.text1};
  text-decoration: none;
  padding: 5px 20px;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.color.brand3} 0%,
    ${({ theme }) => theme.color.brand4} 100%
  );
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 0 0px 1px rgba(255, 255, 255, 0.4);

  > span {
    margin-left: 5px;
    font-weight: bold;
  }
  &:after {
    content: '';
    position: absolute;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    top: 0;
    left: 0;
    height: 300%;
    width: 30px;
    transform: rotate(45deg) translateY(-50%) translateX(-335%);
    transform-origin: center;
  }
  &:hover:after {
    transform: rotate(45deg) translateY(-50%) translateX(335%);
    transition: all 0.5s ease-in-out;
  }
`

const HeaderImgLink = styled(Link)`
  height: 40px;
`
const HeaderImg = styled.img`
  height: 100%;
`

export {
  HeaderWrapper,
  HeaderInnerWrapper,
  HeaderButton,
  HeaderImgLink,
  HeaderImg,
}
